import React from 'react';

export default function AllCampusesModalContent() {
  return (
    <div>
      <p>
        The number of closed, Principles of Excellence-related, complaints for
        schools with the same six-digit OPEID code.
      </p>
    </div>
  );
}
